import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import moment from 'moment';
import _ from 'lodash';
import classes from '../../PossiblePersons/Analytics/analytics.module.scss';
import AnalyticsChartWrapper from '../../PossiblePersons/Analytics/ChartComtonents/AnalyticsChartWrapper';
import { useQuery } from '../../../../utils/hooks/useQuery';
import api from '../../../../api/api';
import Loader from '../../../_common/Loader/Loader';

const chartTemplate = {
  series: [{
    name: 'Active Users',
    data: [],
  }],
  chart: {
    type: 'bar',
    height: 350,
    stacked: true,
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: true,
    },
  },
  dataLabels: {
    show: false,
    enabled: false,
  },
  responsive: [{
    breakpoint: 480,
    options: {
      legend: {
        position: 'bottom',
        offsetX: -10,
        offsetY: 0,
      },
    },
  }],
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 10,
      dataLabels: {
        total: {
          enabled: false,
          style: {
            fontSize: '13px',
            fontWeight: 900,
          },
        },
      },
      columnWidth: '50%',
    },
  },
  xaxis: {
    type: 'category',
    categories: [],
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    labels: {
      style: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '16px',
        textAlign: 'center',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        colors: '#615E83',
      },
    },
  },
  yaxis: {
    labels: {
      style: {
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        lineHeight: '16px',
        textAlign: 'center',
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        colors: '#615E83',
      },
    },
  },
  legend: {
    show: false,
    position: 'right',
    offsetY: 40,
  },
  fill: {
    type: 'gradient',
    colors: ['#962DFF'],
    gradient: {
      type: 'vertical',
      gradientToColors: ['#962DFF'],
      opacityFrom: 1,
      opacityTo: 0.1,
      stops: [7],
    },
  },
  // colors: ['#962DFF'],
  grid: {
    strokeDashArray: 5,
    colors: '#E5E5EF',
  },
};

const thisMonthStartDay = moment().startOf('month').format('YYYY-MM-DD');
const thisMonthEndDate = moment().format('YYYY-MM-DD');

function ActiveUsers(props) {
  const { query, setQuery } = useQuery();

  const {
    usId, usName, usStart, usEnd,
  } = query;

  const [chart, setChart] = useState(chartTemplate);
  const [loading, setLoading] = useState(false);

  const [healthValue, setHealthValue] = useState(usName || '');

  const [requestData, setRequestData] = useState({
    start: usStart || thisMonthStartDay,
    end: !usStart ? thisMonthEndDate : (usEnd || ''),
    healthPlanId: usId || '',
    healthPlanName: usName || '',
  });

  const {
    start, end, healthPlanId, healthPlanName,
  } = requestData;

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { data } = await api.getActiveUsers({
        startDate: start,
        endDate: end || moment(start).add(1, 'day').format('YYYY-MM-DD'),
        healthPlanId,
      });

      setQuery({
        ...query, usStart: start, usEnd: end, usId: healthPlanId, usName: healthPlanName,
      });

      const dataArray = data.counts.map((d) => d.qty);
      const categories = data.counts.map((d) => d.userName);

      setChart((prev) => ({
        ...prev,
        series: [{
          name: 'Active Users',
          data: dataArray,
        }],
        yaxis: {
          ...prev.yaxis,
          max: Math.max(...dataArray),
        },
        xaxis: {
          ...prev.xaxis,
          categories,
        },
      }));

      setLoading(false);
    })();
  }, [requestData]);

  const changeDateAndHealth = (value, path, planName) => {
    setRequestData((prev) => {
      if (path === 'date') {
        return {
          ...prev,
          start: value[0],
          end: value[1],
        };
      }

      return {
        ...prev,
        [path]: value,
        healthPlanName: planName,
      };
    });
  };

  return (
    <AnalyticsChartWrapper
      title="Most active users"
      date={requestData}
      healthValue={healthValue}
      setHealthValue={setHealthValue}
      onChange={changeDateAndHealth}
      className={classes.bottom_chart_analytics}
    >
      {loading
        ? <div className={classes.loader_wrapper}><Loader /></div>

        : _.max(chart?.series?.[0]?.data) === 0 && !loading
          ? <div className={classes.notResult}>No Data Found</div>

          : (
            <Chart
              options={chart}
              series={chart.series}
              height={300}
              type="bar"
              width="100%"
            />
          )}

    </AnalyticsChartWrapper>
  );
}

export default ActiveUsers;
